import React, { useState, useEffect } from 'react';
import { TextField, InputLabel, Button, Select, MenuItem, Radio, FormLabel, FormControl, RadioGroup, FormControlLabel } from '@mui/material';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const NewPaymentForm = ({ isOpen, onClose, selectedRowData,createdID }) => {
    const [Invoice, setInvoice] = useState('');
    const [Client, setClient] = useState('');
    const [ClientID, setClientID] = useState('');
    const [ClientPhone, setClientPhone] = useState('');
    const [PaymentType, setPaymentType] = useState('');
    const [UserType, setUserType] = useState('Client');
    const [PaymentDate, setPaymentDate] = useState('');
    const [Amount, setAmount] = useState('');
    const [Notes, setNotes] = useState('');
    const [Clientdata, setClientData] = useState([]);
    const [Invoicedata, setInvoiceData] = useState([]);
    const [SelectedImageFile, setSelectedImageFile] = useState(null);
    const [chequeNumber, setChequeNumber] = useState('')
    const [refNumber, setRefNumber] = useState('')


    const postData = async () => {
        if (UserType === "Invoice") {
            if (!Invoice || !PaymentDate || !PaymentType || !UserType || !Amount) {
                console.log("EMPTY FIELD")
            }
            else {
                const formData = new FormData();
                formData.append('chequeimage', SelectedImageFile);
                formData.append('clientinvoice', Invoice);
                formData.append('paymentdate', PaymentDate);
                formData.append('paymenttype', PaymentType);
                formData.append('type', UserType);
                formData.append('amountstatus', Amount);
                formData.append('notes', Notes);

                const response = await axios.post(
                    `${process.env.REACT_APP_BASE_URL}/payments/add_payment`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );
                if (response.status === 200) {
                    toast("Payment created successfully!", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        // transition: Bounce,
                    });
                    createdID(parseInt(response.data.payment));
                    
                }
            }
        }
        else if (UserType === "Client") {
            if (!Client || !PaymentDate || !PaymentType || !UserType || !Amount) {
                console.log("EMPTY FIELD")
            }
            else {
                const formData = new FormData();
                formData.append('chequeimage', SelectedImageFile);
                formData.append('clientid',ClientID);
                formData.append('clientinvoice', Client);
                formData.append('clientphone', ClientPhone);
                formData.append('paymentdate', PaymentDate);
                formData.append('paymenttype', PaymentType);
                formData.append('type', UserType);
                formData.append('amountstatus', Amount);
                if(PaymentType==="Bank Transfer"){
                    formData.append('notes', `Ref Number:${refNumber} ${Notes}`);
                    }
                else if(PaymentType==="Cheque"){
                    formData.append('notes', `Cheque No.:${chequeNumber} ${Notes}`);
                    }
                else {
                    formData.append('notes', Notes);
                }
                
                formData.append('chequenumber', chequeNumber);
                formData.append('refnumber', refNumber);
                
                const response = await axios.post(
                    `${process.env.REACT_APP_BASE_URL}/payments/add_payment`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );
                if (response.status === 200) {
                    toast("Payment created successfully!", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        // transition: Bounce,
                    });
                    createdID(parseInt(response.data.payment));
                }
            }
        }
    }


    const updateData = async () => {
        if (UserType === "Client") {
            const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/payments/edit_payment`, {
                id: selectedRowData.id,
                clientinvoice: Client,
                paymentdate: PaymentDate,
                paymenttype: PaymentType,
                amountstatus: Amount,
                notes: Notes,
                type: UserType
            })
            if (response.status === 200) {
                toast("Payment updated successfully!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    // transition: Bounce,
                    });
                console.log(response)
            }
        } else if (UserType === "Invoice") {
            const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/payments/edit_payment`, {
                id: selectedRowData.id,
                clientinvoice: Invoice,
                paymentdate: PaymentDate,
                paymenttype: PaymentType,
                amountstatus: Amount,
                notes: Notes,
                type: UserType
            })
            if (response.status === 200) {
                toast("Payment updated successfully!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    // transition: Bounce,
                    });
                console.log(response)
            }
        }
    }


    useEffect(() => {


        const fetchClients = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/clients/all_clients`);
                const responseData = await response.json();
                if (responseData) {
                    const clientsWithData = responseData.client.map(client => ({
                        id:client.id,
                        firstname: client.companyname,
                        phone: client.phone, // Add the phone property
                    }));
                    setClientData(clientsWithData);
                }
            } catch (error) {
                // Handle errors here
                console.error("Error fetching data:", error);
            }
        }

        const fetchInvoices = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/invoices/all_invoices`);
                const responseData = await response.json();
                if (responseData) {
                    const filteredInvoices = responseData.invoice;
                    setInvoiceData(filteredInvoices);
                }
            } catch (error) {
                // Handle errors here
                console.error("Error fetching data:", error);
            }
        };


        fetchInvoices();
        fetchClients();


        if (selectedRowData !== null) {

             if (selectedRowData.type === "Client") {
                setClient(selectedRowData.clientinvoice);
                setUserType(selectedRowData.type);
                setPaymentType(selectedRowData.paymenttype);
                setPaymentDate(selectedRowData.paymentdate);
                setAmount(selectedRowData.amountstatus);
                if (selectedRowData.notes) {
                    setNotes(selectedRowData.notes);
                } else {
                    setNotes('');
                }
            }
        }
        else {
            setInvoice('');
            setClient('');
            setUserType('Client');
            setPaymentDate('');
            setPaymentType('');
            setAmount('');
            setNotes('');
        }
    }, [selectedRowData]);


    const handleSubmit = (event) => {
        event.preventDefault();

        if (selectedRowData) {
            updateData()
        }
        else {
            postData()
        }
        setInvoice('');
        setClient('');
        setUserType('Client');
        setPaymentDate('');
        setPaymentType('');
        setAmount('');
        setNotes('');

        // onClose();
    };

    return (
        <div style={{
            display: isOpen ? 'block' : 'none',
            position: 'fixed',
            height:'80vh',
            overflowY:'auto',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            padding: '20px',
            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
            zIndex: '999',
            backdropFilter: 'blur(5px)',
        }}>
             <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <h2 className='text-2xl font-bold font-poppins ml-2 mt-3 mb-3'>{selectedRowData ? "Update payment" : "Add New Payment"}</h2>
            <form onSubmit={handleSubmit} encType="multipart/form-data">


                    <>
                        <FormControl fullWidth>
                            <InputLabel id="client">Client</InputLabel>
                            <Select
                                labelId="client"
                                id="client"
                                value={Client}
                                label="Client"
                                onChange={(e) => {
                                    const selectedClient = e.target.value;
                                    setClient(selectedClient);

                                    // Find the selected client's phone number from Clientdata
                                    const selectedClientData = Clientdata.find(client => client.firstname === selectedClient);
                                    if (selectedClientData) {
                                        setClientPhone(selectedClientData.phone);
                                        setClientID(selectedClientData.id)
                                    }
                                }}
                                sx={{ mb: 4 }}
                            >
                                {Clientdata.map((client, index) => (
                                    <MenuItem key={index} value={client.firstname}>
                                        {client.firstname}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>


                    </>

                <TextField
                    type="date"
                    variant="outlined"
                    color="secondary"
                    onChange={(e) => setPaymentDate(e.target.value)}
                    value={PaymentDate}
                    fullWidth
                    required
                    sx={{ mb: 4 }}
                />
                <FormControl fullWidth>
                    <InputLabel id="payment-type">Payment Type</InputLabel>
                    <Select
                        labelId="payment-type"
                        id="payment-type"
                        value={PaymentType}
                        label="Payment Type"
                        onChange={(e) => setPaymentType(e.target.value)}
                        sx={{ mb: 4 }}
                    >
                        <MenuItem value="Cash">Cash</MenuItem>
                        <MenuItem value="Cheque">Cheque</MenuItem>
                        <MenuItem value="Bank Transfer">Bank Transfer</MenuItem>
                        {/* <MenuItem value="Credit">Credit Note</MenuItem> */}
                    </Select>
                </FormControl>
                {PaymentType==="Cheque" && (
                    <>
                        <TextField
                            type="text"
                            variant="outlined"
                            color="secondary"
                            label="Cheque Number"
                            onChange={(e) => setChequeNumber(e.target.value)}
                            value={chequeNumber}
                            fullWidth
                            sx={{ mb: 4 }}
                        />
                    </>
                )}
                {PaymentType==="Bank Transfer" && (
                    <>
                        <TextField
                            type="text"
                            variant="outlined"
                            color="secondary"
                            label="Ref. Number"
                            onChange={(e) => setRefNumber(e.target.value)}
                            value={refNumber}
                            fullWidth
                            sx={{ mb: 4 }}
                        />
                    </>
                )}
                <TextField
                    type="number"
                    variant="outlined"
                    color="secondary"
                    label="Amount"
                    onChange={(e) => setAmount(e.target.value)}
                    value={Amount}
                    fullWidth
                    required
                    sx={{ mb: 4 }}
                />
                <TextField
                    type="text"
                    variant="outlined"
                    color="secondary"
                    label="Descripiton (Optional)"
                    onChange={(e) => {
                        setNotes(e.target.value)
                    }}
                    value={Notes}
                    fullWidth
                    sx={{ mb: 4 }}
                /> 
                <div style={{ display: PaymentType === "Cheque" ? "block" : "none" }}>
                    <input
                        accept="image/*"
                        style={{ display: 'none' }}
                        id="raised-button-file"
                        type="file"
                        name="chequeimage" // Ensure this matches the middleware setup
                        onChange={(e) => {
                            const file = e.target.files[0];
                            setSelectedImageFile(file);
                        }}
                    />
                    <label htmlFor="raised-button-file">
                        <Button className='w-[120px]' variant="raised" component="span">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 10.5v6m3-3H9m4.06-7.19l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z" />
                            </svg>
                        </Button>
                    </label>
                    {SelectedImageFile && (
                        <div>
                            <img
                                src={URL.createObjectURL(SelectedImageFile)}
                                alt="Selected"
                                style={{ maxWidth: '50%', maxHeight: '50px' }}
                            />
                        </div>
                    )}
                </div>
                <button
                    type='submit'
                    className='w-[120px] text-white rounded font-bold font-poppins text-white bg-[#007FFF] p-2 mr-5 mt-2 mb-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75'
                >
                    {selectedRowData ? "Update Payment" : "Add Payment"}
                </button>
            </form>
            <button
                onClick={onClose}
                className='w-[120px] text-red-500 border border-red-500 rounded font-bold font-poppins bg-white p-2 mr-5 mt-2 mb-2 hover:bg-red-500 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75'
            >
                Close
            </button>
           
        </div>
    );
};

export default NewPaymentForm;
